/*
 * Guard for the Ownprint personalization block.
 *
 * Why this exists: Ownprint's personalization.js (ownprint-1-8) only checks
 * required fields on the "Buy now" path. The normal add-to-cart path posts to
 * /cart/add.js without checking them, so a product lands in the cart with no
 * photo and no text, and Ownprint has nothing to engrave. Found on
 * 24 September 2026; reported to Ownprint. Remove this file once their block
 * validates add-to-cart itself.
 *
 * How: Ownprint listens on `document` in the capture phase. A capture listener
 * on `window` always runs before that, whatever order the scripts load in, so
 * this can stop the event before Ownprint sends it.
 */
(function () {
  if (window.__ownprintRequiredGuard) return;
  window.__ownprintRequiredGuard = true;

  var ROOT_SELECTOR = '[data-ownprint-personalization]';
  var ATC_SELECTOR =
    '[name="add"], button[type="submit"], input[type="submit"], [data-add-to-cart], .product-form__submit';
  var PAYMENT_SELECTOR =
    '[data-shopify="payment-button"], .shopify-payment-button, shopify-accelerated-checkout, [name="checkout"]';

  function message() {
    var holder = document.querySelector('[data-ownprint-required-message]');
    return (holder && holder.getAttribute('data-ownprint-required-message')) || '';
  }

  function firstIncomplete(root) {
    var fields = root.querySelectorAll('input[required], select[required], textarea[required]');
    for (var i = 0; i < fields.length; i += 1) {
      var el = fields[i];
      if (el.closest('[hidden]')) continue;
      if (el.type === 'file') {
        if (!el.files || !el.files.length) return el;
      } else if (el.type === 'checkbox' || el.type === 'radio') {
        var group = root.querySelectorAll('[name="' + el.name + '"]:checked');
        if (!group.length) return el;
      } else if (!String(el.value || '').trim()) {
        return el;
      }
    }
    return null;
  }

  function showError(root, text) {
    var box = root.querySelector('[data-ownprint-error]');
    if (!box) return;
    box.textContent = text;
    box.hidden = !text;
  }

  function isAddToCart(event) {
    var target = event.target;
    if (event.type === 'submit') {
      return !!(target && target.tagName === 'FORM' && (target.getAttribute('action') || '').indexOf('/cart/add') !== -1);
    }
    if (!target || !target.closest) return false;
    if (target.closest(PAYMENT_SELECTOR)) return false;
    return !!target.closest(ATC_SELECTOR);
  }

  function guard(event) {
    if (!isAddToCart(event)) return;
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;
    var missing = firstIncomplete(root);
    if (!missing) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var text = message();
    showError(root, text);
    if (missing.scrollIntoView) missing.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (missing.focus) missing.focus({ preventScroll: true });

    // Ownprint's error box sits at the bottom of the block, out of view once we
    // scroll to the field. The browser's own validation bubble shows the same
    // text right at the field. Cleared again as soon as the customer types.
    if (text && missing.setCustomValidity && missing.reportValidity) {
      missing.setCustomValidity(text);
      missing.reportValidity();
      var clear = function () {
        missing.setCustomValidity('');
        missing.removeEventListener('input', clear);
        missing.removeEventListener('change', clear);
      };
      missing.addEventListener('input', clear);
      missing.addEventListener('change', clear);
    }
  }

  window.addEventListener('click', guard, true);
  window.addEventListener('submit', guard, true);
})();
